import { render } from "./NoteList.vue?vue&type=template&id=1595e910"
import script from "./NoteList.vue?vue&type=script&lang=js"
export * from "./NoteList.vue?vue&type=script&lang=js"

import "./NoteList.vue?vue&type=style&index=0&id=1595e910&lang=css"
script.render = render

export default script